<template>
    <div
        :class="`config-set-distribution-status config-set-distribution-status-${row.status}`"
        data-test-id="config-set-distribution-status"
    >
        {{ statusDisplay }}
    </div>
</template>

<script>
import ConfigurationSetDistributionStatuses from '@/constants/configuration-set-distribution-statuses.js'

export default {
    props: ['row'],

    computed: {
        statusDisplay() {
            return ConfigurationSetDistributionStatuses[this.row.status] ?? 'Unknown'
        },
    },
}
</script>
<style lang="scss" scoped>
.config-set-distribution-status {
    border-radius: 8px;
    padding: 6px 12px;
    display: inline-block;
    color: #141218;
    &-EXPIRED {
        background-color: #ffb3af;
    }
    &-DISTRIBUTED {
        background-color: #ffeaa1;
    }
    &-ACTIVE {
        background-color: #84db82;
    }
    &-SCHEDULED {
        background-color: #bec3dc;
    }
}
</style>
